export default {
  async getProducts ({ commit }, query) {
    const { data } = await this.$axios.get('/public/catalog/search', {
      params: { ...query, storeCode: this.$i18n.locale }
    })

    commit('setProducts', data)

    return data
  },

  getProductByAuctionId ({ commit }, auctionId) {
    return this.$axios
      .get(`/public/catalog/auction/get/${auctionId}`)
      .then((response) => {
        const data = response.data
        commit('setAuction', {
          auctionId,
          data
        })
      })
  },

  addToWatchList ({ commit }, productEntityId) {
    commit('addToWatchList', productEntityId)
  },

  removeFromWatchList ({ commit }, productEntityId) {
    commit('removeFromWatchList', productEntityId)
  }
}
